/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { Alert, FormGroup, Label, CustomInput, Modal, ModalHeader, ModalBody, Button, Input } from "reactstrap"
import { reportQuestion } from "api/@vp/assess"
import { connect } from "react-redux"
import SweetAlert from 'react-bootstrap-sweetalert'
import { AlertOctagon } from "react-feather"

const DropdownField = (props) => {
  const employmentTypeList = ["Full-time", "Part-time", "Self-employed", "Freelance", "Contract", "Internship", "Apprenticeship"]
  const monthRange = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  const yearRange = Array.from({length: 40}, (_, n) => new Date().getFullYear() + 5 - n)

  const salutations = ["Mr", "Ms", "Dr"]
  const relationshipRange = ['Superior', 'Direct Supervisor', 'Mentor', 'Teacher', 'Peers', 'Employee', 'Personal Referee', 'Others']
  const relationshipDurationRange = ['Under 3 months', '3-6 months', '6-12 months', '1-3 years', 'More than 3 years']
  const relationshipEngagementRange = ['Yearly', 'Quarterly', 'Monthly', 'Weekly', 'Daily']

  const { formRef } = props

  const { reportable, assessmentContext } = props
  const [modalActive, toggleModal] = useState(false)
  const [offenseRadio, toggleRadio] = useState(1)
  const [feedback, updateFeedback] = useState('')
  const [loading, toggleLoading] = useState(false)

  const onReportSubmit = async () => {
    toggleLoading(true)
    await reportQuestion({
      credentials: assessmentContext.reference,
      target: { teams: props.teams, id: props.id, name: props.name, index: props.index },
      reports: { offenseRadio, feedback }
    })
  }

  return (
    <>
      <FormGroup>
        <Label for={props.id} className='form-label'>
          {props.title} <span>{!props.required && '(Optional)'}</span>
          {
            reportable &&
            <a className='form-report' onClick={
              () => toggleModal(true)
            }>
              {' '}<AlertOctagon size={15} className="form-report-text" />
              <span className="form-report-text">{ ' report question'}</span>
            </a>
          }
        </Label>
        <CustomInput
          id={`select-${props.title}-${props.name}`}
          className="input-dropdown"
          innerRef={formRef.register({
            required: props.required
          })}
          name={
            props.index !== undefined && props !== null
              ? `${props.name}[${props.index}]`
              : props.name
          }
          type="select"
          invalid={
            props.index !== undefined && props !== null
              ? (formRef.errors && formRef.errors[props.name] && (formRef.errors[props.name][props.index] !== undefined))
              : (formRef.errors && (formRef.errors[props.name] !== undefined))
          }
          >
          {
            props.options === 'employmentType'
            &&
            <React.Fragment>
            <option value="" hidden>-</option>
            {employmentTypeList.map((type) => <option key={`employmentType-${type}`} value={type}>{type}</option>
            )}
            </React.Fragment>
          }
          {
            props.options === 'month'
            &&
            <React.Fragment>
            <option value="" hidden>Month</option>
            {monthRange.map((month, index) => (
              <option key={`month-${month}`} value={index + 1}>{month}</option>
            ))}
            </React.Fragment>
          }
          {
            props.options === 'year'
            &&
            <React.Fragment>
            <option value="" hidden>Year</option>
            {yearRange.map((year) => (
              <option key={`year-${year}`} value={year}>{year}</option>
            ))}
            </React.Fragment>
          }
          {
            props.options === 'templateId'
            &&
            <React.Fragment>
            {/* <option value="" hidden>Select...</option> */}
            <option value="1">Vita General Assessment</option>
            <option value="333" disabled>Coming Soon: Vita Technology Assessment</option>
            <option value="444" disabled>Coming Soon: Vita Service Assessment</option>
            <option value="555" disabled>Coming Soon: Vita Sales Assessment</option>
            </React.Fragment>
          }
          {
            props.options === 'templateIdTeams'
            &&
            <React.Fragment>
            <option value="" hidden>Select...</option>
            <option value="1">SMU IIE Founder's Assessment</option>
            <option value="444" disabled>Coming Soon: Founder's Synergy Assessment</option>
            <option value="555" disabled>Coming Soon: Startup Traction Validation</option>
            </React.Fragment>
          }
          {
            props.options === 'indexList'
            &&
            <React.Fragment>
            <option value="" hidden>Select...</option>
            {props.indexList && props.indexList.map((claim, i) => (
              <option key={`claims-${claim}-${i}`} value={i}>{claim}</option>
            ))}
            </React.Fragment>
          }
          {
            props.options === 'customOptions'
            &&
            <React.Fragment>
            <option value="" hidden>Select...</option>
            {props.customOptions && props.customOptions.map((options, i) => (
              <option key={`custom-dropdown-${options}`} value={options}>{options}</option>
            ))}
            </React.Fragment>
          }
          {
            props.options === 'salutation'
            &&
            <React.Fragment>
            <option value="" hidden>-</option>
            {salutations.map((sal) => (
              <option key={`salutation-${sal}`} value={sal}>{sal}</option>
            ))}
            </React.Fragment>
          }
          {
            props.options === 'relationship'
            &&
            <React.Fragment>
            <option value="" hidden>-</option>
            {relationshipRange.map((rel) => (
              <option key={`relationship-${rel}`} value={rel}>{rel}</option>
            ))}
            </React.Fragment>
          }
          {
            props.options === 'relationshipDuration'
            &&
            <React.Fragment>
            <option value="" hidden>-</option>
            {relationshipDurationRange.map((relDur) => (
              <option key={`relationshipDuration-${relDur}`} value={relDur}>{relDur}</option>
            ))}
            </React.Fragment>
          }
          {
            props.options === 'relationshipEngagement'
            &&
            <React.Fragment>
            <option value="" hidden>-</option>
            {relationshipEngagementRange.map((relEng) => (
              <option key={`relationshipEngagement-${relEng}`} value={relEng}>{relEng}</option>
            ))}
            </React.Fragment>
          }
        </CustomInput>
      </FormGroup>

      {
        reportable &&
        <Modal className="modal-form modal-dialog-centered" isOpen={modalActive} toggle={() => toggleModal(false)}>
          <ModalHeader toggle={() => toggleModal(false)}>Report This Question: {props.title}</ModalHeader>
          <ModalBody className="px-2">
            <Label className='form-label'>Please let us know:</Label>
            <Alert onClick={() => toggleRadio(1)} color={offenseRadio === 1 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>This question is not relevant</span></div>
            </Alert>
            <Alert onClick={() => toggleRadio(2)} color={offenseRadio === 2 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>This question is inappropriate</span></div>
            </Alert>
            <Alert onClick={() => toggleRadio(3)} color={offenseRadio === 3 ? 'primary' : 'secondary'}>
              <div className='alert-body'><span className='font-weight-bold'>Others</span></div>
            </Alert>
            <Label for={`report-${props.id}`} className='form-label'>Feedback:</Label>
            <Input id={`report-${props.id}`} type={'text'} onChange={(e) => updateFeedback(e.target.value)} />
            <Button className="m-0 mt-1 w-100" color="primary" onClick={onReportSubmit}>Submit</Button>
          </ModalBody>
          {loading &&
            <SweetAlert info showConfirm onConfirm={() => { toggleLoading(false); toggleModal(false); }}>
              <div className="sweet-alert-text">Thank you for your feedback, we will get back to you!</div>
            </SweetAlert>
          }
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => {
  return {
    assessmentContext: state.platform.vp.assessmentContext || state.platform.vt.assessmentContext,
  }
}

export default connect(mapStateToProps)(DropdownField)
